export interface LocaleInterface {
  language: string;
  locale: string;
}

export const locales: LocaleInterface[] = [
  {
    language: 'en-US',
    locale: 'en',
  },
  {
      language: 'fr-CA',
      locale: 'fr',
  },
];
